import { render, staticRenderFns } from "./qaList.vue?vue&type=template&id=5bedc188&scoped=true"
import script from "./qaList.vue?vue&type=script&lang=js"
export * from "./qaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bedc188",
  null
  
)

export default component.exports